module.exports = __webpack_public_path__ + "img/IMPORT.9a8615f0.svg";